// src/pages/tfdSelect/TFDSelect.js

import { Link } from "react-router-dom";
import React from "react";

const TFDSelect = () => {
	return (
		<div className="container" style={{ padding: "60px 20px" }}>
			<h1>TFD SELECT</h1>
			<p>
				Welcome to Total Football Development SELECT—your gateway to
				professional-level football training, competitions, and opportunities in
				Perth.
			</p>
			<ul>
				<li>
					<Link to="/tfd-select/academy">Academy</Link>
				</li>
				<li>
					<Link to="/tfd-select/private-sessions">Private Sessions</Link>
				</li>
				<li>
					<Link to="/tfd-select/perth-champions-league">
						Perth Champions League
					</Link>
				</li>
				<li>
					<Link to="/tfd-select/camps">Camps</Link> (Info Needed)
				</li>
				<li>
					<Link to="/tfd-select/national-tours">National Tours</Link> (Info
					Needed)
				</li>
				<li>
					<Link to="/tfd-select/international-tours">International Tours</Link>{" "}
					(Info Needed)
				</li>
				<li>
					<Link to="/tfd-select/player-history">Player History</Link> (Info
					Needed)
				</li>
				<li>
					<Link to="/tfd-select/meet-the-team">Meet the Team</Link> (Info
					Needed)
				</li>
			</ul>
		</div>
	);
};

export default TFDSelect;
